import { render } from "./ModalConfiguracao.vue?vue&type=template&id=fcbf2100&scoped=true"
import script from "./ModalConfiguracao.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracao.vue?vue&type=script&lang=js"

import "./ModalConfiguracao.vue?vue&type=style&index=0&id=fcbf2100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcbf2100"]])

export default __exports__